var map = {
	"./add.svg": 1480,
	"./arrow-down.svg": 1759,
	"./arrow-left.svg": 5648,
	"./arrow-right.svg": 6415,
	"./battery.svg": 5958,
	"./camera.svg": 8854,
	"./car.svg": 2575,
	"./check-circle.svg": 2670,
	"./check-ok.svg": 1308,
	"./check.svg": 2497,
	"./close.svg": 5837,
	"./doorlock.svg": 5686,
	"./down.svg": 667,
	"./error.svg": 5119,
	"./eye-cross.svg": 7661,
	"./eye.svg": 4426,
	"./lupa.svg": 7395,
	"./moped.svg": 7998,
	"./motorcycle.svg": 8200,
	"./up.svg": 7572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;